import { getStoreAccessors } from 'typesafe-vuex';
import { AdminState } from '../state';
import { State } from '@/store/state';
import { getters } from '../getters';

const { read } = getStoreAccessors<AdminState, State>('');

export const readAdminOneUser = read(getters.adminOneUser);
export const readAdminUsers = read(getters.adminUsers);
export const readOneService = read(getters.oneService);
export const readContracts = read(getters.contracts);
export const readServices = read(getters.services);
export const readOneSender = read(getters.oneSender);
export const readSenders = read(getters.senders);
export const readOneTemplate = read(getters.oneTemplate);
export const readTemplates = read(getters.templates);
export const readOneProxyError = read(getters.oneProxyError);
export const readProxyErrors = read(getters.proxyErrors);
export const readPriorities = read(getters.priorities);
export const readMNOs = read(getters.mnos);
export const readOneMNO = read(getters.oneMNO);
export const readMNOMasks = read(getters.mnoMasks);
export const readMNOSenders = read(getters.mnoSenders);
export const readTemplateProxyResponse = read(getters.templateProxyResponse);
export const readCheckMNOMaskResponse = read(getters.checkMNOMaskResponse);
export const readOneServiceBanPolicy = read(getters.oneServiceBanPolicy);
export const readServiceBanPolicies = read(getters.serviceBanPolicies);
export const readTags = read(getters.tags);
